import { useDroppable } from "@dnd-kit/core";
import { classNames } from "@/react/helpers/twMergeWithCN";
import type { DroppableData } from "@circle-react-shared/BuilderUI/BuilderUI.types";
import type { BlockCategoryName } from "@circle-react-shared/BuilderUI/constants/BlockCategories";
import { Preview, type PreviewProps } from "./Preview";

interface DroppablePreviewProps extends PreviewProps {
  accepts: BlockCategoryName[];
  childrenArrayPath: string;
  index: number;
  rejects: BlockCategoryName[];
}

export const DroppablePreview = ({
  block,
  path,
  accepts,
  rejects,
  index,
  childrenArrayPath,
  className,
  ...rest
}: DroppablePreviewProps) => {
  const data: DroppableData = {
    path: childrenArrayPath,
    index: index + 1,
    accepts,
    rejects,
  };

  const id = `${childrenArrayPath}:${index + 1}`;

  const { isOver, setNodeRef } = useDroppable({ id, data });

  return (
    <Preview
      {...rest}
      ref={setNodeRef}
      block={block}
      path={path}
      data-droppable-preview
      data-droppable-preview-is-over={isOver}
      className={classNames(className, {
        "droppable-preview--isOver [box-shadow:0_3px_0_0_#3b82f6]": isOver,
      })}
    />
  );
};
